import { CodeBook } from "@king-ict/eupisi-ui/models";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";

import type { IOibPersonData } from "../../oib";
import type { PersonDetails } from "../../../models/Request";

export function buildOibPersonDataFromRequestChild(params: {
  child: PersonDetails | undefined;
  alternativeCodeTypes: CodeBook[] | undefined;
  alternativeCodeReasons: CodeBook[] | undefined;
  handleChildDocumentNumberChange: (value: string) => void;
  handleChildDocumentTypeChange: (value: number) => void;
  handleChildDocumentReasonChange: (value: number) => void;
  handleChildNameChange: (
    value: string,
    field: "firstName" | "lastName"
  ) => void;
}): IOibPersonData {
  const {
    child,
    alternativeCodeTypes,
    alternativeCodeReasons,
    handleChildDocumentNumberChange,
    handleChildDocumentTypeChange,
    handleChildDocumentReasonChange,
    handleChildNameChange,
  } = params;

  return {
    alternativeCodeValue: child?.person?.alternativeDocumentNumber ?? "",
    onAlternativeCodeChange: handleChildDocumentNumberChange,
    alternativeTypeId: child?.person?.alternativeDocumentTypeId ?? null,
    alternativeTypeOptions: codeBookToSelectData(alternativeCodeTypes),
    onAlternativeTypeChange: (value: string) =>
      handleChildDocumentTypeChange(
        Number.isNaN(Number.parseInt(value, 10))
          ? Number.NaN
          : Number.parseInt(value, 10)
      ),
    alternativeReasonId: child?.person?.alternativeDocumentReasonId ?? null,
    alternativeReasonOptions: codeBookToSelectData(alternativeCodeReasons),
    onAlternativeReasonChange: (value: string) =>
      handleChildDocumentReasonChange(
        Number.isNaN(Number.parseInt(value, 10))
          ? Number.NaN
          : Number.parseInt(value, 10)
      ),
    lastNameValue: child?.lastName ?? "",
    onLastNameChange: (value: string) =>
      handleChildNameChange(value, "lastName"),
    firstNameValue: child?.firstName ?? "",
    onFirstNameChange: (value: string) =>
      handleChildNameChange(value, "firstName"),
  };
}

export function buildOibPersonDataFromRequestParent(params: {
  parent: PersonDetails | undefined;
  alternativeCodeTypes: CodeBook[] | undefined;
  alternativeCodeReasons: CodeBook[] | undefined;
  handleParentDocumentNumberChange: (value: string) => void;
  handleParentDocumentTypeChange: (value: number) => void;
  handleParentDocumentReasonChange: (value: number) => void;
  handleParentNameChange: (
    value: string,
    field: "firstName" | "lastName"
  ) => void;
}): IOibPersonData {
  const {
    parent,
    alternativeCodeTypes,
    alternativeCodeReasons,
    handleParentDocumentNumberChange,
    handleParentDocumentTypeChange,
    handleParentDocumentReasonChange,
    handleParentNameChange,
  } = params;

  return {
    alternativeCodeValue: parent?.person?.alternativeDocumentNumber ?? "",
    onAlternativeCodeChange: handleParentDocumentNumberChange,
    alternativeTypeId: parent?.person?.alternativeDocumentTypeId ?? null,
    alternativeTypeOptions: codeBookToSelectData(alternativeCodeTypes),
    onAlternativeTypeChange: (value: string) =>
      handleParentDocumentTypeChange(
        Number.isNaN(Number.parseInt(value, 10))
          ? Number.NaN
          : Number.parseInt(value, 10)
      ),
    alternativeReasonId: parent?.person?.alternativeDocumentReasonId ?? null,
    alternativeReasonOptions: codeBookToSelectData(alternativeCodeReasons),
    onAlternativeReasonChange: (value: string) =>
      handleParentDocumentReasonChange(
        Number.isNaN(Number.parseInt(value, 10))
          ? Number.NaN
          : Number.parseInt(value, 10)
      ),
    lastNameValue: parent?.lastName ?? "",
    onLastNameChange: (value: string) =>
      handleParentNameChange(value, "lastName"),
    firstNameValue: parent?.firstName ?? "",
    onFirstNameChange: (value: string) =>
      handleParentNameChange(value, "firstName"),
  };
}
